import { useState, FunctionComponent } from 'react';

// components
import Contact1stdibsModalLazy from './Contact1stdibsModalLazy';

// helpers
import { trackFooterNavigationClick } from '../../helpers/trackingHelpers';

type Props = {
    trackingLabel: string;
    serverRenderedChildren: string;
};

const Contact1stdibsFooterLinkWrapper: FunctionComponent<Props> = ({
    trackingLabel,
    serverRenderedChildren,
}) => {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions*/}
            <span
                onClick={() => {
                    setIsContactModalOpen(true);
                    trackFooterNavigationClick({ label: trackingLabel });
                }}
            >
                {serverRenderedChildren}
            </span>
            <Contact1stdibsModalLazy
                isOpen={isContactModalOpen}
                placement="globalFooter"
                onClose={() => setIsContactModalOpen(false)}
            />
        </>
    );
};

export default Contact1stdibsFooterLinkWrapper;
